import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QRCodeCanvas } from 'qrcode.react';
import { Stack, Typography } from '@mui/material';

import { AppDispatch, RootState } from 'redux/store';
import { createQRCode, downloadQR, getQRCodeById, getQRCodes, QR_STATUS } from 'redux/slices/qr/qrCodeSlice';
import CardWrapper from 'components/Common/CardWrapper';
import MenuList from 'components/Common/MenuList';

const ViewQRCode = () => {
    const dispatch = useDispatch<AppDispatch>();
    const merchant = useSelector((state: RootState) => state.user.defaultMerchant);
    const { allQrCodes, qrStrings } = useSelector((state: RootState) => state.qrCode);
    const qrCode = allQrCodes?.[0] || {};
    useEffect(() => {
        getQr();
    }, []); // eslint-disable-line

    const getQr = useCallback(async () => {
        try {
            // FIRST OF ALL WE ARE GETTING THE LIST OF CODES IF ANY AND IF NOT THEN WE ARE CREATING THE CODE FOR THE
            // COMPANY AND THEN WE WILL GET THE CREATE CODE WITH GET REQUEST BECAUSE CREATE REQUEST DO NOT RETURN
            // THE CREATED CODE DATA

            const { payload, error }: any = await dispatch(getQRCodes(QR_STATUS.ACTIVE));
            if (!payload && error?.message !== 'Network Error') {
                const res = await dispatch(createQRCode({ label: 'Catholic-MS', description: 'default' }));
                if (res?.payload) {
                    await dispatch(getQRCodes(QR_STATUS.ACTIVE));
                }
            }
        } catch (error) {
            console.log(error);
        }
    }, [dispatch]);
    const handleDownloadQR = () => {
        downloadQR('qrcode', qrCode?.id || 'qrCode');
    };
    return (
        <CardWrapper>
            <Stack width="100%" alignItems="flex-end">
                <MenuList
                    mt={4}
                    menuItems={[
                        { item: 'Download', onClick: handleDownloadQR },
                        { item: 'Print', hide: true, onClick: () => console.log('print') },
                        // You can add more menu items with their onClick functions here
                    ]}
                />
            </Stack>
            <Stack alignItems="center" mb={5}>
                <Typography fontSize="35px" mb={3}>
                    {merchant?.name}
                </Typography>
                <QRCodeCanvas id="qrcode" value={getQRCodeById(qrStrings, qrCode?.id || '')} size={300} />
            </Stack>
        </CardWrapper>
    );
};

export default ViewQRCode;
